module.exports = __webpack_public_path__ + "./images/tubepurple.94a980.jpg";